/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import _documentEditing from './editorContents/documentEditing.html?raw';
import _articleEditor from './editorContents/articleEditor.html?raw';
import _notionLike from './editorContents/notionLike.html?raw';
import _microEditor from './editorContents/microEditor.html?raw';
import _htmlEditor from './editorContents/htmlEditor.html?raw';
import _featureRichEditor from './editorContents/featureRichEditor.html?raw';
import _balloonEditor from './editorContents/balloonEditor.html?raw';
import _emailEditor from './editorContents/emailEditor.html?raw';
import _snippetEvaluationHeader from './editorContents/snippetEvaluationHeader.html?raw';
import _snippetEvaluationHeaderWithLink from './editorContents/snippetEvaluationHeaderWithLink.html?raw';
import _snippetInitialContent from './editorContents/snippetInitialContent.html?raw';
import _snippetInitialContentWithLink from './editorContents/snippetInitialContentWithLink.html?raw';

export const documentEditing: string = _documentEditing;
export const articleEditor: string = _articleEditor;
export const notionLike: string = _notionLike;
export const microEditor: string = _microEditor;
export const htmlEditor: string = _htmlEditor;
export const featureRichEditor: string = _featureRichEditor;
export const balloonEditor: string = _balloonEditor;
export const emailEditor: string = _emailEditor;

export const snippetEvaluationHeader: string = _snippetEvaluationHeader;
export const snippetEvaluationHeaderWithLink: string = _snippetEvaluationHeaderWithLink;
export const snippetInitialContent: string = _snippetInitialContent;
export const snippetInitialContentWithLink: string = _snippetInitialContentWithLink;
